/**
 * Both languages the widget supports, kept in one frozen map the way
 * apps/widget/modules/widget/lib/widget-locale.ts does.
 *
 * Which one is used comes from the request row, not the browser: the form is
 * opened long after it was sent, on whatever device the customer happens to
 * have, so the language the agent chose has to travel with the link.
 */
export const STRINGS = {
  en: {
    submit: "Submit",
    saveChanges: "Save changes",
    submitting: "Sending…",
    required: "Required",
    optional: "optional",
    thanks: "Thanks — we’ve got your details.",
    canEditOnce: "You can come back and change this once.",
    submitIsFinal:
      "Please check your answers — you cannot change them after sending.",
    editingNow: "You can update your answers once. This is that one time.",
    noMoreEdits: "This form has been completed and can no longer be changed.",
    closedTitle: "This link is no longer active",
    closedBody:
      "It may have expired or already been completed. Ask the person you were speaking with for a new one.",
    // Deliberately not "this link is dead": we did not get far enough to know.
    errorTitle: "We couldn’t load this form",
    errorBody:
      "Check your connection and try again. The link itself is probably fine.",
    retry: "Try again",
    loading: "Loading…",
    problem: "Something went wrong. Please try again.",
    fixErrors: "Please check the highlighted answers.",
    noEditsLeft: "This form can no longer be changed.",
    unavailable: "This link is no longer active.",
    stale:
      "These answers were changed on another device. Reload the page to see the latest version.",
    errors: {
      required: "This one is needed.",
      invalid_email: "That doesn’t look like an email address.",
      invalid_phone: "That doesn’t look like a phone number.",
      invalid_url: "Enter a full address starting with https://",
      invalid_date: "Use the date picker.",
      not_a_number: "Numbers only.",
      not_an_integer: "Whole numbers only.",
      not_an_option: "Pick one of the options.",
      too_long: "That’s a bit too long.",
    } as Record<string, string>,
    choose: "Choose…",
    yes: "Yes",
  },
  ar: {
    submit: "إرسال",
    saveChanges: "حفظ التعديلات",
    submitting: "جارٍ الإرسال…",
    required: "مطلوب",
    optional: "اختياري",
    thanks: "شكرًا — وصلتنا بياناتك.",
    canEditOnce: "يمكنك العودة وتعديل هذه البيانات مرة واحدة.",
    submitIsFinal: "يرجى مراجعة إجاباتك — لا يمكن تعديلها بعد الإرسال.",
    editingNow: "يمكنك تعديل إجاباتك مرة واحدة، وهذه هي.",
    noMoreEdits: "تم إكمال هذا النموذج ولم يعد قابلًا للتعديل.",
    closedTitle: "لم يعد هذا الرابط صالحًا",
    closedBody:
      "قد تكون صلاحيته انتهت أو تم إكماله بالفعل. اطلب رابطًا جديدًا ممن كنت تتحدث إليه.",
    errorTitle: "تعذّر تحميل النموذج",
    errorBody: "تحقق من اتصالك وحاول مرة أخرى. الرابط نفسه على الأرجح سليم.",
    retry: "حاول مرة أخرى",
    loading: "جارٍ التحميل…",
    problem: "حدث خطأ ما. حاول مرة أخرى.",
    fixErrors: "يرجى مراجعة الإجابات المحددة.",
    noEditsLeft: "لم يعد بالإمكان تعديل هذا النموذج.",
    unavailable: "لم يعد هذا الرابط صالحًا.",
    stale: "تم تعديل هذه الإجابات من جهاز آخر. أعد تحميل الصفحة لرؤية أحدث نسخة.",
    errors: {
      required: "هذا الحقل مطلوب.",
      invalid_email: "هذا لا يبدو بريدًا إلكترونيًا.",
      invalid_phone: "هذا لا يبدو رقم هاتف.",
      invalid_url: "أدخل عنوانًا كاملًا يبدأ بـ https://",
      invalid_date: "استخدم منتقي التاريخ.",
      not_a_number: "أرقام فقط.",
      not_an_integer: "أرقام صحيحة فقط.",
      not_an_option: "اختر أحد الخيارات.",
      too_long: "هذا طويل قليلًا.",
    } as Record<string, string>,
    choose: "اختر…",
    yes: "نعم",
  },
};

export type Strings = (typeof STRINGS)["en"];
